import { render, staticRenderFns } from "./SelectedFilter.vue?vue&type=template&id=354df9e2&"
import script from "./SelectedFilter.vue?vue&type=script&lang=js&"
export * from "./SelectedFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports